<script setup lang="ts">
import { type ReserveType } from '@utils/itinerary';
import type SiteUtmCampaign from '@store/content/entities/SiteUtmCampaign';

const { campaign } = defineProps<{
    campaign: SiteUtmCampaign;
}>();
const emit = defineEmits<{
    close: [];
}>();
const searchFormStore = useSearchFormStore();
const isCopied = ref(false);
const loaded = ref(false);
const moreTitle = computed(() => (isCopied.value ? 'کپی شد' : 'کپی کد تخفیف'));
const onClose = () => {
    if (campaign.reserveTab) {
        searchFormStore.setReserveType(campaign.reserveTab as ReserveType);
    }
    emit('close');
};
const copyDiscount = () => {
    copyTextToClipboard(campaign.couponCode || '');
    isCopied.value = true;
    setTimeout(() => {
        isCopied.value = false;
    }, 3000);
};
</script>
<template>
    <mr-modal :title="campaign.title" @close="emit('close')">
        <div class="campaign-container">
            <div v-if="campaign.videoUrl" class="video-player-container">
                <div v-show="!loaded" class="loader loading-skeleton" />
                <iframe
                    :src="campaign.videoUrl"
                    style="border: 0 #ffffff none"
                    name="Final Mrbilit.MOV"
                    frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen="true"
                    webkitallowfullscreen="true"
                    mozallowfullscreen="true"
                    @load="loaded = true"
                />
            </div>
            <mr-blur-hash-image
                v-else-if="campaign.image"
                :src="campaign.image.src"
                :hash="campaign.image.blurHash"
                image-fit="contain"
            />
        </div>
        <template #footer>
            <div class="actions">
                <mr-button
                    v-if="campaign.couponCode"
                    class="mr-button"
                    full-width
                    variant="bordered"
                    @click="copyDiscount"
                >
                    {{ moreTitle }}
                </mr-button>
                <mr-button
                    v-else
                    link
                    target="_blank"
                    :href="campaign.detailsUrl"
                    full-width
                    class="mr-button"
                    variant="bordered"
                >
                    اطلاعات بیشتر
                </mr-button>
                <mr-button class="mr-button" full-width @click="onClose">
                    {{ campaign.closeTitle }}
                </mr-button>
            </div>
        </template>
    </mr-modal>
</template>

<style lang="scss" scoped>
.campaign-container {
    width: 450px;
    height: 298px;
    @include mobile-only {
        width: 100vw;
        height: 66vw;
    }
}

.video-player-container {
    position: relative;
    overflow: hidden;
    width: 450px;
    height: auto;
    padding-top: 56.25%;
    @include mobile-only {
        width: 100%;
    }
    iframe,
    .loader {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border: 0;
    }
}

.actions {
    align-self: stretch;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 20px;
    gap: 12px;
}
</style>
